'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _AccordionItemBody = require('../AccordionItemBody');

var _AccordionItemBody2 = _interopRequireDefault(_AccordionItemBody);

var _AccordionItemTitle = require('../AccordionItemTitle');

var _AccordionItemTitle2 = _interopRequireDefault(_AccordionItemTitle);

var _AccordionItem = require('./AccordionItem.scss');

var _AccordionItem2 = _interopRequireDefault(_AccordionItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AccordionItem, _Component);

  function AccordionItem(props) {
    (0, _classCallCheck3.default)(this, AccordionItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AccordionItem.__proto__ || (0, _getPrototypeOf2.default)(AccordionItem)).call(this, props));

    _this.timeout = null;
    _this.uuid = null;

    // Elements
    _this.item = null;
    _this.title = null;
    _this.body = null;

    _this.state = {
      maxHeight: props.expanded ? props.maxHeightWhenExpanded : 0,
      overflow: props.expanded ? props.overflowWhenExpanded : 'hidden',
      duration: props.transitionDuration
    };
    return _this;
  }

  (0, _createClass3.default)(AccordionItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.uuid = this.props.uuid || _uuid2.default.v4();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.expanded !== this.props.expanded) {
        if (this.props.expanded) {
          this.maybeExpand();
        } else {
          this.handleCollapse();
        }
      }
    }

    /* GETTERS
     ---------------------------------------------------------------------------------------------- */

  }, {
    key: 'startTransition',


    /* HANDLERS AND EVENTS
     ---------------------------------------------------------------------------------------------- */
    value: function startTransition() {
      this.setState({ maxHeight: this.maxHeight, overflow: 'hidden' });
      clearTimeout(this.timeout);
    }
  }, {
    key: 'maybeExpand',
    value: function maybeExpand() {
      var bodyNode = _reactDom2.default.findDOMNode(this.body); // eslint-disable-line react/no-find-dom-node
      var images = bodyNode.querySelectorAll('img');

      if (images.length > 0) {
        this.preloadImages(bodyNode, images);
        return;
      }

      this.handleExpand();
    }
  }, {
    key: 'handleExpand',
    value: function handleExpand() {
      var _this2 = this;

      var _props = this.props,
          onExpand = _props.onExpand,
          maxHeightWhenExpanded = _props.maxHeightWhenExpanded,
          overflowWhenExpanded = _props.overflowWhenExpanded;


      this.startTransition();
      this.timeout = setTimeout(function () {
        _this2.setState({ maxHeight: maxHeightWhenExpanded, overflow: overflowWhenExpanded });

        // Call callback
        if (onExpand) onExpand();
      }, this.state.duration);
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse() {
      var _this3 = this;

      var onClose = this.props.onClose;


      this.startTransition();
      this.timeout = setTimeout(function () {
        _this3.setState({ maxHeight: 0, overflow: 'hidden' });

        // Call callback
        if (onClose) onClose();
      }, 0);
    }

    // Wait for images to load before calculating maxHeight

  }, {
    key: 'preloadImages',
    value: function preloadImages(node) {
      var _this4 = this;

      var images = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var imagesLoaded = 0;

      var imgLoaded = function imgLoaded() {
        imagesLoaded += 1;
        if (imagesLoaded === images.length) _this4.handleExpand();
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(images), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var img = _step.value;

          var _img = new Image();
          _img.src = img.src;
          _img.onload = _img.onerror = imgLoaded;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx,
          _this5 = this;

      var _state = this.state,
          duration = _state.duration,
          overflow = _state.overflow,
          maxHeight = _state.maxHeight;
      var _props2 = this.props,
          className = _props2.className,
          expandedClassName = _props2.expandedClassName,
          bodyClassName = _props2.bodyClassName,
          bodyWrapperClassName = _props2.bodyWrapperClassName,
          titleClassName = _props2.titleClassName,
          expanded = _props2.expanded,
          children = _props2.children,
          title = _props2.title,
          style = _props2.style,
          onClick = _props2.onClick;


      return _react2.default.createElement(
        'div',
        {
          role: 'tabpanel',
          className: (0, _classnames2.default)(className, _AccordionItem2.default.root, (_cx = {}, (0, _defineProperty3.default)(_cx, expandedClassName, expanded && expandedClassName), (0, _defineProperty3.default)(_cx, _AccordionItem2.default['root--expanded'], expanded && _AccordionItem2.default['root--expanded']), _cx)),
          style: style,
          ref: function ref(c) {
            _this5.item = c;
          },
          'aria-hidden': !expanded,
          'aria-expanded': expanded
        },
        _react2.default.createElement(_AccordionItemTitle2.default, {
          className: (0, _classnames2.default)(titleClassName, _AccordionItem2.default.title),
          title: title,
          ref: function ref(c) {
            _this5.title = c;
          },
          uuid: this.uuid,
          onClick: onClick
        }),
        _react2.default.createElement(
          _AccordionItemBody2.default,
          {
            className: (0, _classnames2.default)(bodyClassName, _AccordionItem2.default.body),
            wrapperClassName: (0, _classnames2.default)(bodyWrapperClassName, _AccordionItem2.default.bodyWrapper),
            duration: duration,
            overflow: overflow,
            maxHeight: maxHeight,
            ref: function ref(c) {
              _this5.body = c;
            },
            uuid: this.uuid
          },
          children
        )
      );
    }
  }, {
    key: 'maxHeight',
    get: function get() {
      var body = _reactDom2.default.findDOMNode(this.body); // eslint-disable-line react/no-find-dom-node
      return body.scrollHeight + 'px';
    }
  }]);
  return AccordionItem;
}(_react.Component), _class.Body = _AccordionItemBody2.default, _class.Title = _AccordionItemTitle2.default, _class.propTypes = {
  /* Text to display in header */
  title: _react.PropTypes.node.isRequired,
  /* Key used in activeItems lookup */
  slug: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  /* If item body should be expanded or not */
  expanded: _react.PropTypes.bool,
  /* Content of the body */
  children: _react.PropTypes.node.isRequired,
  /* Duration of the transition */
  transitionDuration: _react.PropTypes.number,
  /* Overflow when the Accordion is expanded */
  overflowWhenExpanded: _react.PropTypes.string,
  /* Max Height when the Accordion is expanded */
  maxHeightWhenExpanded: _react.PropTypes.string,
  /* Unique identifier of the item */
  uuid: _react.PropTypes.string,

  /* Callback for when item is expanded */
  onExpand: _react.PropTypes.func,
  /* Callback for when item closes */
  onClose: _react.PropTypes.func,
  /* Callback for when item title is clicked */
  onClick: _react.PropTypes.func,

  /* Custom className applied to root item div */
  className: _react.PropTypes.string,
  /* Custom className applied to the accordion item body */
  bodyClassName: _react.PropTypes.string,
  /* Custom className applied to the accordion item body wrapper */
  bodyWrapperClassName: _react.PropTypes.string,
  /* Custom className applied when accordion is expanded */
  expandedClassName: _react.PropTypes.string,
  /* Custom className applied to accordion item header text */
  titleClassName: _react.PropTypes.string,
  /* Inline styles applied to root div */
  style: _react.PropTypes.object
}, _class.defaultProps = {
  expanded: false,
  transitionDuration: 300,
  overflowWhenExpanded: 'visible',
  maxHeightWhenExpanded: 'none'
}, _temp);
exports.default = AccordionItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/AccordionItem/AccordionItem.jsx
// module id = 657
// module chunks = 0